import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-three',
  templateUrl: './demo-three.component.html',
  styleUrls: ['./demo-three.component.css']
})
export class DemoThreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
